import {Component, Injector, OnInit} from '@angular/core';
import {BaseNewComponents} from '../../base-new-components';
import { ProdutoService as ProductService } from '../../../core/services/produto.service';
import { IPlan } from '../../../core/interfaces/plans-informations.interface';
import { AppComponent } from '../../../app.component';
@Component({
  selector: 'app-plans-informations',
  templateUrl: './plans-informations.component.html',
  styleUrls: ['./plans-informations.component.sass']
})
export class PlansInformationsComponent extends BaseNewComponents implements OnInit {
  plansInformations: Array<Array<IPlan>> = [];
  constructor(
      protected injector: Injector,
      protected productService: ProductService,
      private appComponent: AppComponent
  ) {
    super(injector);
  }

  async ngOnInit() {
    await this.loadPlansInformations();
  }

  async loadPlansInformations() {
    this.appComponent.showOverlay();
    const result = await this.productService.plansInformations();
    const data = result.data.filter((plan: IPlan) => ['COMPLETO', 'IDEAL', 'REQUINTE'].includes(plan.title));
    this.plansInformations = [data];
    this.appComponent.hideOverlay();
  }
  convertPrice(value: string | null) {
    return value ? value.replace('.', ',') : '0';
  }
}
